const {getAsset} = require("utils");
const prefix = "projects/robotics/";

module.exports =
{
	title: "Advanced Robotics",
	website: "https://rmuw.org",
	slogan: "",
	sections:
	[
		{
			image: getAsset(prefix + "cover.jpg"),
		},
		{
			title: "Clashing Robots",
			body:
			`The Advanced Robotics team at the University of Washington competes in an international competition called Robomasters in which universities
			from around the world compete to see who's robots are superior. Teams' robots battle it out in a 4v4 arena and only one comes out alive.`/* +
			`Joining the Advanced Robotics team at the University of Washington was my first time doing any kind of robotics. I was unable to join the
			team during high school because of other time commitments, but having the time for it made it a great opportunity to test and develop my
			skillset. The team is split between mechanical engineering, electrical engineering, and computer science. I serve under the computer science
			branch and on the simulations team. My team's goal is to create a replica of the actual Robomasters game field and the robots and allow
			the pilots in our team to practice the real game.`*/
		},
		{
			title: "Making It Real",
			body:
			`An important part of making the simulation is being as accurate as possible. It's one of the only ways in which the pilots can practice
			before heading to the international stage. Thus we try to make the simulation as exact of a representation as possible of what it'll be
			like to be in the arena. We created exact models of the field with precise measurements by Robomaster's specifications. We then imported
			them into Unity and created the functionality of the tanks, allowed them to move and shoot, and added networking for multiple people to
			be able to play against each other in the simulation. Personally, <strong>I implemented much of the networking logic into the project</strong>.
			I chose to use the Unity High Level API to do this because it was easy to shape it to our needs within our <strong>time constraints</strong>.`,
		},
		{image: getAsset(prefix + "editor.jpg")},
		{image: getAsset(prefix + "ingame.jpg")},
		{
			title: "Looking Ahead",
			body:
			`As we get closer to the competition, which takes place in the summer, we'll be working with the other teams, especially the mechanical
			engineering team to ensure that our simulation accurately emulates the experience of driving actual robots. We'll likely also implement
			an option to practice against a team of AIs or have them fill certain roles. I look forward to seeing the final product and can't wait
			until people are using it.`
		}
	],
}


// WEBPACK FOOTER //
// ./src/js/cases/Robotics.js